import { createAction } from 'redux-actions';

import { IWorkshopPayment } from '@app/types';

const ACTION_PREFIX = '@screen/workshop-enrolment-complete';
const getActionName = (name: string) => `${ACTION_PREFIX}/${name}`;

export const fetchPayment = createAction<number>(getActionName('FETCH_PAYMENT'));
export const fetchPaymentSuccess = createAction<IWorkshopPayment>(getActionName('FETCH_PAYMENT_SUCCESS'));
export const fetchPaymentFail = createAction(getActionName('FETCH_PAYMENT_FAIL'));
